import React from 'react';
import { Box, Button, Typography, Grid, Paper, Card, CardContent, LinearProgress, useTheme, Stack } from "@mui/material";
import { tokens } from '../../../theme';
import styles, { layout } from '../../../style'

const TankVolume = ({ volume }) => {
  const maxVolume = 12000;
  const filledPercentage = (volume / maxVolume) * 100;
  const labels = [9000, 6000, 3000];

  return (
    <Box
      sx={{
        height: 300,
        width: 70,
        borderRadius: 4,
        border: "3px solid #0f172a",
        bgcolor: "#e5e7eb",
        position: "relative",
        overflow: "hidden",
        mb: 1,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: `${filledPercentage}%`,
          bgcolor: "#f59e0b",
          borderRadius: "16px 16px 0 0",
        }}
      />

      {labels.map((l) => (
        <Typography
          key={l}
          variant="caption"
          sx={{
            position: "absolute",
            bottom: `${(l / maxVolume) * 100}%`,
            left: 4,
            color: "#000",
            fontWeight: 600,
          }}
        >
          {l}
        </Typography>
      ))}

      <Typography variant="caption" sx={{ position: "absolute", bottom: 4, left: 4 }}>
        0
      </Typography>
      <Typography variant="caption" sx={{ position: "absolute", top: 4, left: 4 }}>
        {maxVolume}
      </Typography>
    </Box>
  );
};


const CombinedTankInfoCard = ({ tanksData }) => {
  return (
    <Paper
      elevation={8}
      sx={{
        p: 4,
        borderRadius: 4,
        bgcolor: "rgba(15,23,42,0.85)",
        border: "1px solid rgba(148,163,184,0.25)",
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        {tanksData.map((tank) => (
          <Grid
            item
            xs={12}
            sm={4}
            key={tank.name}
            sx={{ textAlign: "left" }}
          >
            <Typography
              variant="subtitle1"
              sx={{ color: "#fff", fontWeight: 800, mb: 1 }}
            >
              {tank.name}
            </Typography>

            <TankVolume volume={tank.volume} />

            <Stack spacing={0.5}>
              <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.8)" }}>
                Volume: {tank.volume} gal
              </Typography>
              <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.8)" }}>
                Ullage: {tank.ullage} gal
              </Typography>
              <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.8)" }}>
                Water: {tank.water_vol} gal ({tank.water_height}&quot;)
              </Typography>
              <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.8)" }}>
                Temp: {tank.temp}°F
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};





const LiveTankDisplays = () => {
  const exampleTankData = [
    { name: "Unleaded", volume: 8000, ullage: 4000, water_vol: 100, water_height: 2, temp: 68 },
    { name: "Premium", volume: 6000, ullage: 6000, water_vol: 150, water_height: 3, temp: 70 },
    { name: "Diesel", volume: 4000, ullage: 8000, water_vol: 50, water_height: 1, temp: 65 },
  ];

  return (
    <Box component="section" id="atg_view" sx={{ py: 10 }}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={7}>
          <CombinedTankInfoCard tanksData={exampleTankData} />
        </Grid>

        <Grid item xs={12} md={5}>
          <Stack spacing={3}>
            <Typography
              variant="h3"
              sx={{ fontWeight: 900, color: "#fff", fontFamily: "Poppins" }}
            >
              Intuitive Live ATG Dashboard
            </Typography>

            <Typography
              variant="h4"
              sx={{ color: "rgba(226,232,240,0.8)" }}
            >
              Live visualization of tank inventory, water levels, ullage, and
              temperature — updated continuously and stored automatically for
              compliance and reporting.
            </Typography>

            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ fontWeight: 800, width: "fit-content" }}
              href="#contact"
            >
              See Full Demo
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LiveTankDisplays;
